import axios, { AxiosPromise } from 'axios';
import ApiService from '@/api/http/ApiService';
import { InjectionRate } from '@/interfaces/models/InjectionRate';

export interface InjectionRateFilter {
  /** Predefined shorthand (1d/1w/1m/1y) or a custom YYYY-MM-DD/YYYY-MM-DD range. */
  period?: string;
  venue?: string;
  customerGroup?: string;
  externalOrderProvider?: string;
}

/**
 * Reporting-service endpoints, reached through the gateway at `v1/reporting/*`
 * (dev-api.smoothr.de / api.smoothr.de).
 */
export default class ReportingApiService extends ApiService<InjectionRate> {
  constructor() {
    super('reporting/kpis');
  }

  public getInjectionRates(filter: InjectionRateFilter): AxiosPromise<InjectionRate[]> {
    return axios.get(`${this.getBaseUrl()}/injection`, { params: filter });
  }
}
